import { Card, Col, Form as BSForm, Row } from 'react-bootstrap';
import { Field, useFormikContext } from 'formik';
import SigniteButton from '../../../../ui-elements/signite-button/signiteButton';
import { useState } from 'react';
import { CandidateService } from '../../../../../services/candidateService';
import { useRef } from 'react';
import Loader from 'react-spinner-loader';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
export const DiscreetReferenceCheckForm = ({ handleChange, values, countryCodes, handleBlur, errors, touched }) => {
  const [loader, setLoader] = useState(false);
  const { setFieldValue } = useFormikContext();
  const fileUploadHandler = (data) => {
    setFieldValue(`reference1.report[0].originalName`, data.originalName);
    setFieldValue(`reference1.report[0].path`, data.path);
  };
  const fileUploadHandler2 = (data) => {
    setFieldValue(`reference2.report[0].originalName`, data.originalName);
    setFieldValue(`reference2.report[0].path`, data.path);
  };

  const inputFile = useRef(null);
  const inputFile2 = useRef(null);
  const handleFileChange = (event) => {
    console.log(event.target.files[0]);
    if (event.target.files[0]) {
      console.log('File selection captured!', event.target.files[0]);
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      switch (event.target.id) {
        case 'REF1_REPORT':
          CandidateService.uploadFile(formData, event.target.id, fileUploadHandler, setLoader);
          break;
        case 'REF2_REPORT':
          CandidateService.uploadFile(formData, event.target.id, fileUploadHandler2, setLoader);
          break;
      }
    }
  };

  const handleDownload = (type, filePath, fileName) => {
    CandidateService.downloadFile(type, filePath)
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'document.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };



  const removeFile = (field) => {
    setFieldValue(field, []);
    if (field === 'reference1.report') inputFile.current.value = '';
    else inputFile2.current.value = '';
  };
  return (
    <div className="signite-form">
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
      <Row className="mb-3">
        <h5 style={{ fontWeight: 600 }}>Reference 1</h5>
        <BSForm.Group as={Col} controlId="previousReportingManagerName">
          <BSForm.Label>Name</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference1.name`}
            value={_.get(values, `reference1.name`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference1.designation">
          <BSForm.Label>Designation</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference1.designation`}
            value={_.get(values, `reference1.designation`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference1.organisation">
          <BSForm.Label>Organization</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference1.organisation`}
            value={_.get(values, `reference1.organisation`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference1.phoneNumber">
          <Row key={`phone-r1`}>
            <Col md={4} lg={4}>
              <BSForm.Label>Country Code</BSForm.Label>
              <BSForm.Select
                name={`reference1.phoneNumber.countryCode`}
                value={_.get(values, `reference1.phoneNumber.countryCode`)}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, `reference1.phoneNumber.countryCode`)}`}
              >
                {countryCodes.map((countryCode, index) => (
                  <option value={countryCode.callingCode} key={index}>
                    {countryCode.displayText}
                  </option>
                ))}
              </BSForm.Select>
            </Col>
            <Col md={5} lg={5}>
              <BSForm.Label>Phone Number</BSForm.Label>
              <BSForm.Control
                name={`reference1.phoneNumber.phoneNumber`}
                value={_.get(values, `reference1.phoneNumber.phoneNumber`)}
                onChange={handleChange}
                type="number"
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, `reference1.phoneNumber.phoneNumber`)}`}
              ></BSForm.Control>
              <span className="errorMessage">
                {getErrorMessage(errors, touched, `reference1.phoneNumber.phoneNumber`)}
              </span>
            </Col>
          </Row>
        </BSForm.Group>
      </Row>
      <Row style={{ paddingLeft: 20 }}>
        <div className="file-upload d-flex align-items-center">
          <BSForm.Group as={Col} controlId={'fileUpload'}>
            <SigniteButton variant="primary" className="signiteUploadButton" onClick={() => inputFile.current.click()}>
              Browse..
            </SigniteButton>
            <input
              type="file"
              id="REF1_REPORT"
              ref={inputFile}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept=".doc,.docx,.pdf"
            />
            <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
              {(_.get(values, `reference1.report[0].originalName`) && (
                <span>

                  <a
                    style={{ cursor: 'pointer', color: '#eb4b15' }}
                    onClick={() =>
                      handleDownload(
                        'REF1_REPORT',
                        _.get(values, 'reference1.report[0].path'),
                        _.get(values, 'reference1.report[0].originalName')
                      )
                    }
                  >
                    {_.get(values, 'reference1.report[0].originalName')}
                  </a>
                  {

                    <a
                      onClick={() => removeFile(`reference1.report`)}
                      style={{ marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                    >
                      <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                    </a>
                  }
                </span>
              )) ||
                `Or drop file here`}
            </BSForm.Label>
          </BSForm.Group>
        </div>
      </Row>
      <hr></hr>
      <Row className="mb-3">
        <h5 style={{ fontWeight: 600 }}>Reference 2</h5>
        <BSForm.Group as={Col} controlId="reference2.name">
          <BSForm.Label>Name</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference2.name`}
            value={_.get(values, `reference2.name`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference2.designation">
          <BSForm.Label>Designation</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference2.designation`}
            value={_.get(values, `reference2.designation`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference2.organisation">
          <BSForm.Label>Organization</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`reference2.organisation`}
            value={_.get(values, `reference2.organisation`)}
            onChange={handleChange}
          ></BSForm.Control>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="reference2.phoneNumber">
          <Row key={`phone-r1`}>
            <Col md={4} lg={4}>
              <BSForm.Label>Country Code</BSForm.Label>
              <BSForm.Select
                name={`reference2.phoneNumber.countryCode`}
                value={_.get(values, `reference2.phoneNumber.countryCode`)}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, `reference2.phoneNumber.countryCode`)}`}
              >
                {countryCodes.map((countryCode, index) => (
                  <option value={countryCode.callingCode} key={index}>
                    {countryCode.displayText}
                  </option>
                ))}
              </BSForm.Select>
            </Col>
            <Col md={5} lg={5}>
              <BSForm.Label>Phone Number</BSForm.Label>
              <BSForm.Control
                name={`reference2.phoneNumber.phoneNumber`}
                value={_.get(values, `reference2.phoneNumber.phoneNumber`)}
                onChange={handleChange}
                type="number"
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, `reference2.phoneNumber.phoneNumber`)}`}
              ></BSForm.Control>
              <span className="errorMessage">
                {getErrorMessage(errors, touched, `reference2.phoneNumber.phoneNumber`)}
              </span>
            </Col>
          </Row>
        </BSForm.Group>
      </Row>
      <Row style={{ paddingLeft: 20 }}>
        <div className="file-upload d-flex align-items-center">
          <BSForm.Group as={Col} controlId={'fileUpload'}>
            <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
              <SigniteButton
                variant="primary"
                className="signiteUploadButton"
                onClick={() => inputFile2.current.click()}
              >
                Browse..
              </SigniteButton>
              <input
                type="file"
                id="REF2_REPORT"
                ref={inputFile2}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept=".doc,.docx,.pdf"
              />
              <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
                {(_.get(values, `reference2.report[0].originalName`) && (
                  <span>
                    <a
                      style={{ cursor: 'pointer', color: '#eb4b15' }}
                      onClick={() =>
                        handleDownload(
                          'REF2_REPORT',
                          _.get(values, 'reference2.report[0].path'),
                          _.get(values, 'reference2.report[0].originalName')
                        )
                      }
                    >
                      {_.get(values, 'reference2.report[0].originalName')}
                    </a>
                    {
                      <a
                        onClick={() => removeFile(`reference2.report`)}
                        style={{ marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                      >
                        <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                      </a>
                    }
                  </span>
                )) ||
                  `Or drop file here`}
              </BSForm.Label>
            </BSForm.Label>
          </BSForm.Group>
        </div>
      </Row>
    </div>
  );
};